module.exports = " <div ui-view></div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/subsections/money-movements/inspect.transactions.transactions.html
// module id = 4179
// module chunks = 86